import styles from "./gallery-position-icon.module.css";
import classNames from "classnames";

export type GalleryPosition = "top" | "bottom" | "left" | "right";

interface GalleryPositionIconProps {
  position: GalleryPosition;
  isSelected: boolean;
  onClick: () => void;
}

export const GalleryPositionIcon = (props: GalleryPositionIconProps) => {
  let containerOrientationClass: string = "";
  let containerSideClass: string = "";
  let orientationClass: string = "";
  let sideClass: string = "";

  switch (props.position) {
    case "bottom":
      containerOrientationClass = styles.iconContainerHorizontal;
      containerSideClass = styles.iconContainerEnd;
      orientationClass = styles.galleryHorizontal;
      sideClass = styles.galleryBottom;
      break;
    case "top":
      containerOrientationClass = styles.iconContainerHorizontal;
      containerSideClass = styles.iconContainerStart;
      orientationClass = styles.galleryHorizontal;
      sideClass = styles.galleryTop;
      break;
    case "left":
      containerOrientationClass = styles.iconContainerVertical;
      containerSideClass = styles.iconContainerStart;
      orientationClass = styles.galleryVertical;
      sideClass = styles.galleryLeft;
      break;
    case "right":
      containerOrientationClass = styles.iconContainerVertical;
      containerSideClass = styles.iconContainerEnd;
      orientationClass = styles.galleryVertical;
      sideClass = styles.galleryRight;
      break;
  }

  return (
    <div
      className={classNames(
        styles.iconContainer,
        containerOrientationClass,
        containerSideClass
      )}
      onClick={() => {
        props.onClick();
      }}
    >
      <div
        className={classNames(orientationClass, sideClass, {
          [styles.gallerySelected]: props.isSelected,
        })}
      />
    </div>
  );
};
